import { type FC } from 'react'
import { EvergreenWealthLogo } from '@egw/assets'
import { Link } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'

export const EnrollmentHYCSHeader: FC = () => {
  const { t } = useTranslation('layouts')

  return (
    <div className="w-full min-h-[68px] bg-base-black px-lg py-sm items-center flex">
      <Link href={WEALTH_ROUTES.HOME.path} title={t('header.home_link_title')}>
        <EvergreenWealthLogo className="h-4" />
      </Link>
    </div>
  )
}
